import { isPlayerBlockingType } from '../../../types/playerBlockingTypes';
import { booleanParser, numberParser } from '../inboundParsers';
import { splitWithBraces, trimBraces } from '../inboundUtils';
export const UPDATE_PLAYER_BLOCKING_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [
        { name: 'playerId', parser: numberParser },
        { name: 'blockingTypesToUpdate', parser: blockingTypesToUpdateParser }
    ]
};
function blockingTypesToUpdateParser(str) {
    const blockingTypesToUpdate = {};
    splitWithBraces(trimBraces(str)).forEach((blockingTypeToUpdateString) => {
        const [blockingTypeString, isBlocking] = splitWithBraces(trimBraces(blockingTypeToUpdateString));
        if (isPlayerBlockingType(blockingTypeString)) {
            blockingTypesToUpdate[blockingTypeString] = booleanParser(isBlocking);
        }
    });
    return blockingTypesToUpdate;
}
